module.exports = __webpack_public_path__ + "img/gz.1c142c35.svg";